var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNurseSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.104,
    height: 61.729,
    viewBox: "0 0 48.104 61.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com_1_",
    "data-name": "nurse-svgrepo-com (1)",
    transform: "translate(-43.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M65.228,251.924v10.534h41.24V251.924a8.605,8.605,0,0,0-7.118-8.51,78.655,78.655,0,0,0-27,0A8.589,8.589,0,0,0,65.228,251.924Z",
    transform: "translate(-18.468 -204.146)",
    fill: "#a3387c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M87.014,278.026v-7.107c0-2.542,1.881-4.362,4.281-5.125,4.179-1.352,21.5-1.3,25.816,0,2.41.732,4.281,2.593,4.281,5.125v7.107Z",
    transform: "translate(-36.828 -223.151)",
    fill: "#fae7f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35813",
    "data-name": "Group 35813",
    transform: "translate(43.313 34.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M81.452,221.536a82,82,0,0,0-28.185,0,12.03,12.03,0,0,0-9.954,11.886v12.252a1.716,1.716,0,0,0,1.718,1.718H89.7a1.716,1.716,0,0,0,1.718-1.718V233.442A12.051,12.051,0,0,0,81.452,221.536Zm6.528,22.44H46.76V233.442a8.605,8.605,0,0,1,7.118-8.51,78.658,78.658,0,0,1,27,0,8.615,8.615,0,0,1,7.117,8.51l-.01,10.534Z",
    transform: "translate(-43.313 -220.316)",
    fill: "#a3387c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M225.712,273.678h-2.318v-2.318a1.718,1.718,0,1,0-3.437,0v2.318h-2.318a1.718,1.718,0,1,0,0,3.437h2.318v2.318a1.718,1.718,0,1,0,3.437,0v-2.318h2.318a1.718,1.718,0,1,0,0-3.437Z",
    transform: "translate(-188.773 -261.883)",
    fill: "#a3387c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M141.612,21.786c-4.84,0-8.917,4.026-10.005,9.476a.06.06,0,0,1-.051.02c6.233-1.373,7.341-2.806,7.5-3.111a1.665,1.665,0,0,1,3.162.335c.193.376,1.8,2.918,9.629,4.626C151.444,26.809,147.011,21.786,141.612,21.786Z",
    transform: "translate(-74.364 -18.359)",
    fill: "#f8cfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M150.587,89.758c-6.548-1.352-9.761-3.366-11.317-4.942-1.484,1.047-4.118,2.176-9.009,3.172.315,6.477,4.789,11.632,10.259,11.632C145.422,99.61,149.611,95.38,150.587,89.758Z",
    transform: "translate(-73.273 -71.476)",
    fill: "#f8cfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M122.108,0c-7.331,0-13.34,6.6-13.686,15.008-.01.254-.01.508-.01.763,0,8.7,6.151,15.78,13.706,15.78,7.117,0,13.116-6.4,13.665-14.56,0-.051.051-.864.051-1.23C135.814,7.077,129.673,0,122.108,0ZM111.849,16.5c4.891-1,7.524-2.125,9.009-3.172,1.556,1.576,4.769,3.589,11.317,4.942-.976,5.643-5.165,9.852-10.066,9.852C116.648,28.134,112.164,22.979,111.849,16.5Zm10.89-6.314a1.662,1.662,0,0,0-3.162-.335c-.163.3-1.261,1.739-7.5,3.111a.06.06,0,0,1,.051-.02c1.068-5.47,5.155-9.476,10.005-9.476,5.4,0,9.832,5.023,10.249,11.378C124.538,13.086,122.932,10.544,122.738,10.188Z",
    transform: "translate(-54.86)",
    fill: "#a3387c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseSvgrepoCom);
export default __webpack_public_path__ + "static/media/nurse-svgrepo-com.ed061b629ad5f4764f599338494ce0c8.svg";
export { ForwardRef as ReactComponent };